export default "__VITE_ASSET__CWIuKUaO__"